module.exports = __webpack_public_path__ + "static/img/2-1.7d73cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/2-1.jpg
// module id = iQq/
// module chunks = 25